/* Wise V23 « Hiver » — page d'accueil (agent B)
   Héros diaporama, rails produits, apparitions au scroll.
   Sans dépendance, chargé en defer. Compatible éditeur de thème. */
(function () {
  'use strict';

  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var FINE = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------
     HÉROS
     ------------------------------------------------------------------ */
  function initHero(root) {
    if (!root || root.__h23) return;
    var slides = $$('[data-h23-slide]', root);
    var dots = $$('[data-h23-dot]', root);
    var n = slides.length;
    root.__h23 = { go: function () {} };
    if (!n) return;

    var idx = 0;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) idx = i; });

    var auto = root.getAttribute('data-autoplay') === 'true' && n > 1 && !RM.matches;
    var track = root.querySelector('[data-h23-track]');
    var pauseBtn = root.querySelector('[data-h23-pause]');
    var state = { user: false, hover: false, focus: false, off: false, editor: false };

    if (auto) root.classList.add('is-auto');

    function paused() { return state.user || state.hover || state.focus || state.off || state.editor || document.hidden; }

    function videoOf(i) { return slides[i] && slides[i].querySelector('video'); }

    function playVideo(i) {
      var v = videoOf(i);
      if (!v) return;
      v.muted = true; v.playsInline = true; v.loop = true;
      v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      if (RM.matches || state.user || state.off) { v.pause(); return; }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function stopVideo(i) { var v = videoOf(i); if (v) v.pause(); }

    $$('video', root).forEach(function (v) {
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    });

    function sync() {
      root.classList.toggle('is-paused', paused());
      if (state.user || state.off) stopVideo(idx); else playVideo(idx);
    }

    function restartBar(i) {
      var bar = dots[i] && dots[i].querySelector('.h23__bar i');
      if (!bar) return;
      bar.style.animation = 'none';
      void bar.offsetWidth;
      bar.style.animation = '';
    }

    function go(i, fromUser) {
      i = (i + n) % n;
      if (i === idx) { restartBar(i); return; }
      var prev = slides[idx];
      prev.classList.remove('is-active');
      prev.setAttribute('aria-hidden', 'true');
      prev.setAttribute('inert', '');
      stopVideo(idx);
      if (dots[idx]) { dots[idx].classList.remove('is-active'); dots[idx].removeAttribute('aria-current'); }

      idx = i;
      var cur = slides[idx];
      cur.classList.add('is-active');
      cur.removeAttribute('aria-hidden');
      cur.removeAttribute('inert');
      if (dots[idx]) { dots[idx].classList.add('is-active'); dots[idx].setAttribute('aria-current', 'true'); }
      restartBar(idx);
      if (track) track.setAttribute('aria-live', fromUser ? 'polite' : 'off');
      sync();
    }
    root.__h23.go = go;

    // Avance automatique : fin de l'animation de la barre active.
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i, true); });
      var bar = d.querySelector('.h23__bar i');
      if (bar) bar.addEventListener('animationend', function () {
        if (auto && i === idx && !paused()) go(idx + 1, false);
      });
    });

    var prevBtn = root.querySelector('[data-h23-prev]');
    var nextBtn = root.querySelector('[data-h23-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1, true); });

    if (pauseBtn) {
      if (!auto) pauseBtn.hidden = true;
      pauseBtn.addEventListener('click', function () {
        state.user = !state.user;
        pauseBtn.setAttribute('aria-pressed', state.user ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', state.user ? 'Reprendre le diaporama' : 'Mettre le diaporama en pause');
        sync();
      });
    }

    // Pause au survol et au focus clavier.
    root.addEventListener('mouseenter', function () { state.hover = true; sync(); });
    root.addEventListener('mouseleave', function () { state.hover = false; sync(); });
    root.addEventListener('focusin', function () { state.focus = true; sync(); });
    root.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !root.contains(e.relatedTarget)) { state.focus = false; sync(); }
    });

    // Clavier : flèches gauche / droite quand le focus est dans le héros.
    root.addEventListener('keydown', function (e) {
      if (n < 2) return;
      if (e.key === 'ArrowRight') { go(idx + 1, true); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { go(idx - 1, true); e.preventDefault(); }
    });

    // Balayage tactile.
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) go(idx + (dx < 0 ? 1 : -1), true);
    }, { passive: true });

    // Hors écran / onglet caché : pause.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        state.off = !entries[0].isIntersecting; sync();
      }, { threshold: 0.2 }).observe(root);
    }
    document.addEventListener('visibilitychange', sync);

    // Parallaxe douce du collage produits (ordinateur uniquement).
    if (FINE.matches && !RM.matches) {
      var raf = 0, px = 0, py = 0;
      root.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect();
        px = ((e.clientX - r.left) / r.width - 0.5) * 2;
        py = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          root.style.setProperty('--h23-px', px.toFixed(3));
          root.style.setProperty('--h23-py', py.toFixed(3));
        });
      });
      root.addEventListener('pointerleave', function () {
        root.style.setProperty('--h23-px', '0');
        root.style.setProperty('--h23-py', '0');
      });
    }

    // Précharger les visuels des autres diapositives une fois la page chargée.
    function warm() { $$('img[loading="lazy"]', root).forEach(function (img) { img.loading = 'eager'; }); }
    if (document.readyState === 'complete') setTimeout(warm, 600); else window.addEventListener('load', function () { setTimeout(warm, 600); });

    // Éditeur de thème : afficher la diapositive sélectionnée.
    root.__h23.select = function (blockId) {
      slides.forEach(function (s, i) { if (s.getAttribute('data-block-id') === blockId) { state.editor = true; go(i, true); } });
    };
    root.__h23.deselect = function () { state.editor = false; sync(); };

    sync();
  }

  /* ------------------------------------------------------------------
     RAILS PRODUITS
     ------------------------------------------------------------------ */
  function initRail(root) {
    if (!root || root.__pr23) return;
    root.__pr23 = true;
    var track = root.querySelector('[data-pr23-track]');
    if (!track) return;
    var prev = root.querySelector('[data-pr23-prev]');
    var next = root.querySelector('[data-pr23-next]');
    var bar = root.querySelector('[data-pr23-bar]');
    var ticking = false;

    function step() {
      var item = track.querySelector('li');
      if (!item) return track.clientWidth * 0.9;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var w = item.getBoundingClientRect().width + gap;
      return Math.max(1, Math.floor((track.clientWidth + gap) / w)) * w;
    }
    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('is-static', max <= 4);
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
      if (bar && track.scrollWidth > 0) {
        var ratio = Math.min(1, track.clientWidth / track.scrollWidth);
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.style.width = (ratio * 100) + '%';
        bar.style.transform = 'translateX(' + (pos * (1 - ratio) / ratio * 100) + '%)';
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: RM.matches ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: RM.matches ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { track.scrollBy({ left: step(), behavior: 'smooth' }); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { track.scrollBy({ left: -step(), behavior: 'smooth' }); e.preventDefault(); }
    });
    if ('ResizeObserver' in window) new ResizeObserver(onScroll).observe(track);
    else window.addEventListener('resize', onScroll);
    update();
  }

  /* ------------------------------------------------------------------
     APPARITIONS AU SCROLL (seulement sous la ligne de flottaison)
     ------------------------------------------------------------------ */
  var io = null;
  function initReveal(scope) {
    if (DESIGN || RM.matches || !('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    var vh = window.innerHeight || 800;
    $$('[data-v23h-rv]', scope).forEach(function (el) {
      if (el.__rv) return;
      el.__rv = true;
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      el.classList.add('v23h-pre');
      io.observe(el);
    });
  }

  function init(scope) {
    scope = scope || document;
    $$('[data-h23]', scope).forEach(initHero);
    $$('[data-pr23]', scope).forEach(initRail);
    initReveal(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Éditeur de thème */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest && e.target.closest('[data-h23]');
    if (hero && hero.__h23 && hero.__h23.select) hero.__h23.select(e.detail && e.detail.blockId);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var hero = e.target.closest && e.target.closest('[data-h23]');
    if (hero && hero.__h23 && hero.__h23.deselect) hero.__h23.deselect();
  });
})();
